import { Box, Typography } from '@mui/material';
import { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { onlineTourDetailTransportation } from '../api';
import { IOnlineTourTransportationResult } from '../utils/types';
import { TransportationTable } from './TransportationTable';

type OnlineTourDetailTransportationProps = {
  tourId: number;
};

export default function OnlineTourDetailTransportation({
  tourId,
}: OnlineTourDetailTransportationProps) {
  const { t } = useTranslation();
  const [error, setError] = useState<string>();
  const [loading, setLoading] = useState<boolean>(true);
  const [
    onlineTourDetailTransportationResult,
    setOnlineTourDetailTransportationResult,
  ] = useState<IOnlineTourTransportationResult[]>([]);

  useEffect(() => {
    fetchOnlineTourDetailTransportations(tourId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tourId]);

  const fetchOnlineTourDetailTransportations = async (tourId: number) => {
    try {
      const res = await onlineTourDetailTransportation(tourId);
      const data = await res.json();
      if (res?.status === 200) {
        setOnlineTourDetailTransportationResult(data);
      } else {
        throw data;
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e: any) {
      setError(e.detail || t('loginPage.registerErrorMessage'));
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const sortedResults = onlineTourDetailTransportationResult.sort(
    (a, b) =>
      new Date(a?.departureDate).getTime() -
      new Date(b?.departureDate).getTime(),
  );

  const departureTs = sortedResults.filter(
    (res) => res.direction && res.direction === 'DEPARTURE',
  );

  const returnTs = sortedResults.filter(
    (res) => res.direction && res.direction === 'RETURN',
  );

  return (
    <Fragment>
      <Typography sx={{ mb: 1, fontSize: (t) => t.typography.fontSize * 1.4 }}>
        {t('onlineTourDetailTransportation.directionDeparture')}
      </Typography>
      <Box mb={3}>
        <TransportationTable rows={departureTs} />
      </Box>
      <Box>
        <Typography
          sx={{ mb: 1, fontSize: (t) => t.typography.fontSize * 1.4 }}
        >
          {t('onlineTourDetailTransportation.directionReturn')}
        </Typography>
        <TransportationTable rows={returnTs} />
      </Box>
    </Fragment>
  );
}
